
<div>
    <app-component-selector 
        [campusId]="this.campus.campusId" 
        [editionId]="0"
        [webResourceId]="this.webResourceId">
    </app-component-selector>
</div>
